import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/layout/AppShell';
import { EscalarModalProvider } from './components/modals/EscalarModalProvider';
import LoginPage from './pages/LoginPage';
import OverviewRoute from './pages/OverviewRoute';
import ServicesRoute from './pages/ServicesRoute';
import NodesRoute from './pages/NodesRoute';

const ActivityRoute = lazy(() => import('@/pages/ActivityRoute'));
const TasksRoute = lazy(() => import('@/pages/TasksRoute'));
const SearchRoute = lazy(() => import('@/pages/SearchRoute'));
const UsersRoute = lazy(() => import('@/pages/UsersRoute'));
const ClustersRoute = lazy(() => import('@/pages/ClustersRoute'));
const MosaicRoute = lazy(() => import('@/pages/MosaicRoute'));
const PackagesRoute = lazy(() => import('@/pages/PackagesRoute'));
const StatusRoute = lazy(() => import('@/pages/StatusRoute'));
const OpsRoute = lazy(() => import('@/pages/OpsRoute'));
const OpsRunDetailRoute = lazy(() => import('@/pages/OpsRunDetailRoute'));
const OpsMissionsRoute = lazy(() => import('@/pages/OpsMissionsRoute'));
const OpsMissionDetailRoute = lazy(() => import('@/pages/OpsMissionDetailRoute'));
const OpsEffectivenessRoute = lazy(
  () => import('@/pages/OpsEffectivenessRoute')
);
const NotFound = lazy(() => import('@/pages/NotFound'));

function RouteFallback() {
  return (
    <div className="flex h-full w-full items-center justify-center py-12">
      <div
        className="h-5 w-5 animate-spin rounded-full border-2 border-borderSoft border-t-text"
        aria-hidden="true"
      />
      <span className="ml-2 text-[11.5px] text-textMute">Carregando…</span>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <EscalarModalProvider>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<Navigate to="/overview" replace />} />
            <Route element={<AppShell />}>
              <Route path="/overview" element={<OverviewRoute />} />
              <Route path="/services" element={<ServicesRoute />} />
              <Route path="/nodes" element={<NodesRoute />} />
              <Route path="/tasks" element={<TasksRoute />} />
              <Route path="/activity" element={<ActivityRoute />} />
              <Route path="/users" element={<UsersRoute />} />
              <Route path="/clusters" element={<ClustersRoute />} />
              <Route path="/mosaic" element={<MosaicRoute />} />
              <Route path="/packages" element={<PackagesRoute />} />
              <Route path="/status" element={<StatusRoute />} />
              <Route path="/search" element={<SearchRoute />} />
              <Route path="/ops" element={<OpsRoute />} />
              <Route path="/ops/runs/:id" element={<OpsRunDetailRoute />} />
              <Route path="/ops/missions" element={<OpsMissionsRoute />} />
              <Route
                path="/ops/autoscale"
                element={<Navigate to="/ops/missions?aba=limites" replace />}
              />
              <Route
                path="/ops/missions/:id"
                element={<OpsMissionDetailRoute />}
              />
              <Route
                path="/ops/effectiveness"
                element={<OpsEffectivenessRoute />}
              />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </EscalarModalProvider>
    </BrowserRouter>
  );
}
